import { Component, Input, OnInit } from '@angular/core';
import { SeriesMeta } from '../../models/view/series-meta';

@Component({
    selector: 'series',
    templateUrl: './series.component.html',
    styleUrls: ['./series.component.scss']
})
export class SeriesComponent implements OnInit {

    @Input() series: SeriesMeta;


    constructor () {
        // empty
    }


    ngOnInit () {
        // empty
    }

}
